export default "__VITE_ASSET__DBEJ5FRt__"